import React from 'react';
import { Card, CardBody, CardHeader, Col, Nav, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { H5, P } from '../../../../../../AbstractElements';
import { Add, Hometxt, Inbox, MaterialRightTab, Modalcontent, nav_info, Pillspan1, Profile, Settings } from '../../../../../../Constant';
import TabsPreventDefaultAndAnimation from '../../../../../../Hoc/TabsPreventDefaultAndAnimation';

const InfoColorTab = ({ show, tabActive, tabActiveHandler }) => {
  return (
    <Col sm='12' xl='6 xl-100'>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{MaterialRightTab}</H5>
          <span>
            {Add} <code>{nav_info}</code> {Pillspan1}
          </span>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm='9' className='tabs-responsive-side'>
              <TabContent activeTab={tabActive}>
                <TabPane className={`fade ${tabActive === '1' ? show : ''}`} tabId='1'>
                  <P>{Modalcontent}</P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '2' ? show : ''}`} tabId='2'>
                  <P>{Modalcontent}</P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '3' ? show : ''}`} tabId='3'>
                  <P>{Modalcontent}</P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '4' ? show : ''}`} tabId='4'>
                  <P>{Modalcontent}</P>
                </TabPane>
              </TabContent>
            </Col>
            <Col sm='3'>
              <Nav className='flex-column nav-info border-tab nav-right'>
                <NavLink href='#javascript' className={tabActive === '1' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '1')}>
                  {Hometxt}
                </NavLink>

                <NavLink href='#javascript' className={tabActive === '2' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '2')}>
                  {Profile}
                </NavLink>

                <NavLink href='#javascript' className={tabActive === '3' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '3')}>
                  {Inbox}
                </NavLink>

                <NavLink href='#javascript' className={tabActive === '4' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '4')}>
                  {Settings}
                </NavLink>
              </Nav>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabsPreventDefaultAndAnimation(InfoColorTab);
